import React from 'react';
import { useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon } from './types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 24, alt, color, className, onClick }, ref) {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
  return (
    <svg ref={ref} onClick={onClick} width={size} height={size} viewBox='0 0 24 24' fill='none' className={className}>
      <path
        d='M19 19V17.3333C19 16.4493 18.6576 15.6014 18.0481 14.9763C17.4386 14.3512 16.612 14 15.75 14H9.25C8.38805 14 7.5614 14.3512 6.9519 14.9763C6.34241 15.6014 6 16.4493 6 17.3333V19'
        stroke={fillColor}
        strokeWidth='1.6'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12.5 11C14.433 11 16 9.433 16 7.5C16 5.567 14.433 4 12.5 4C10.567 4 9 5.567 9 7.5C9 9.433 10.567 11 12.5 11Z'
        stroke={fillColor}
        strokeWidth='1.6'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
});

export default React.memo(Icon);
